import { ReactElement } from 'react';
import { useViewProvider } from '../../../modules/contexts/view-provider-context/ViewProvider';

export function AgreementWithoutServicePlanModalContent(): ReactElement {
  const viewProvider = useViewProvider();

  return viewProvider.renderAgreementWithoutServicePlanModalContent();
}
